/**
 * @file Rules Component
 * @description Handles the display and acknowledgment of exam rules and lockdown options.
 * Manages the rules acknowledgment flow before an exam begins.
 * @module context/session/components/Rules
 */

import React, { useEffect, useState } from 'react';
import { applyModalityOptions, toHumanReadable } from '../../helpers/helpers';
import {
  Flex,
  View,
  Text,
  IconWarningLine
} from '@smarterservices/smarter-ui';
import { useAppStore } from '../../stores/app';
import SinglePane from '../SinglePane';

const InvalidStatus = () => {

  const sessionStatus = useAppStore((state) => state.sessionStatus);
 
  
  // Main render method
  return (
    <SinglePane>
      <Flex as="div" direction="column" alignItems="center" justifyContent="center" height="100%" width="100%">
        <View 
          as="div" 
          className="rules-and-protocol-content"
          margin="auto"
          textAlign="center"
          borderRadius="large"
          padding="large"
          borderWidth="small"
          borderColor="primary"
          background="primary"
          maxWidth="400px"
        >
          <View as="div" margin="0 0 medium 0" textAlign="center">
            <IconWarningLine color="warning" size="large" />
          </View>
          <Text size="medium">
            This session cannot be started since it is in the <strong>{sessionStatus}</strong> status.
          </Text>
        </View>
      </Flex>
    </SinglePane>
  );
};

/**
 * @exports InvalidStatus
 * @description Default export of the InvalidStatus component
 */
export default InvalidStatus;
